var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5464 12L22.8744 3.672C23.5562 2.9654 23.5459 1.84273 22.8513 1.14873C22.1566 0.454734 21.034 0.445511 20.328 1.128L12 9.4536L3.672 1.128C3.22327 0.646434 2.54747 0.448204 1.90971 0.611077C1.27195 0.773949 0.773949 1.27195 0.611077 1.90971C0.448204 2.54747 0.646434 3.22327 1.128 3.672L9.4536 12L1.128 20.328C0.646434 20.7767 0.448204 21.4525 0.611077 22.0903C0.773949 22.7281 1.27195 23.2261 1.90971 23.3889C2.54747 23.5518 3.22327 23.3536 3.672 22.872L12 14.5464L20.328 22.8744C21.0346 23.5562 22.1573 23.5459 22.8513 22.8513C23.5453 22.1566 23.5545 21.034 22.872 20.328L14.5464 12Z",
    fill: "#20123A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a15ba35e.svg";
export { ForwardRef as ReactComponent };